import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { Notification } from "../../types/Types";

type UpdateNotificationDto = Partial<Notification>;

export const useSaveNotification = (
  options?: UseMutationOptions<
    Notification,
    unknown,
    Notification | UpdateNotificationDto,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<Notification>) => {
      if (data.id) {
        return axiosInstance
          .put(getAPIURL(`/Notification/Update`), data)
          .then((res) => res.data);
      } else {
        return axiosInstance
          .post(getAPIURL("/Notification/Create"), data)
          .then((res) => res.data);
      }
    },
  });
};
